



















import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/helpers/i18nHelper";
import ModalContainer from "@/components/ModalContainer.vue";

export default defineComponent({
  name: "ModalPrompt",
  components: { ModalContainer },
  props: {
    value: { type: Boolean, required: true },
    text: { type: String },
    label: { type: String },
    confirmText: { type: String, default: $t("Yes") },
    cancelText: { type: String, default: $t("No") },
    confirmColor: { type: String, default: "error" },
    cancelColor: { type: String, default: "primary" },
  },
  data() {
    return {
      inputValue: "",
    };
  },
  methods: {
    confirmClick() {
      this.$emit("confirm", this.inputValue, this.resetInput);
    },
    cancelClick() {
      this.$emit("cancel", this.resetInput);
    },
    resetInput() {
      this.inputValue = "";
    },
  },
});
